import { FC, ReactNode } from 'react';

const DEFAULT_PLACEHOLDER = '-';

/**
 * Content wrapper that returns placeholder as fallback
 */
export const CellPlaceholder: FC<{ children?: ReactNode; placeholder?: ReactNode }> = ({
  children,
  placeholder = DEFAULT_PLACEHOLDER,
}) => <>{children || placeholder}</>;
